import { AlertTriangle } from 'lucide-react';
import { cn } from '@/lib';

interface ErrorStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
}

export function ErrorState({ icon, title, description, action, className }: ErrorStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center py-12 text-center', className)}>
      <div className="mb-4 text-red-400">{icon ?? <AlertTriangle className="h-12 w-12" />}</div>
      <h3 className="text-lg font-medium text-admin-text">{title}</h3>
      {description && (
        <p className="mt-1 max-w-md text-sm text-admin-text-secondary">{description}</p>
      )}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
